import React, { useCallback } from 'react';
import { getCurrencySelectOptions } from '../../../internal-components/form-builder/currencies';
import CurrencyComboFieldView from '../view/CurrencyComboFieldView';

const CurrencyComboFieldEngine = ({
  currencySelectSubFieldIndex,
  numberValueSubFieldIndex,
  readOnly,
  subFieldValues,
  setSubFieldValue
}) => {
  const currencyOptions = getCurrencySelectOptions();
  const asyncCurrencyOptions = searchValue => {
    return new Promise((resolve, reject) => {
      try {
        if (searchValue) {
          return resolve(
            currencyOptions.filter(one =>
              one.displayString
                .toLocaleLowerCase()
                .includes(searchValue.toLocaleLowerCase())
            )
          );
        }
        return resolve(currencyOptions);
      } catch (e) {
        reject(e);
      }
    });
  };

  const openMenuOptionParser = useCallback(
    optionObject => {
      const matchingCurrency = currencyOptions.find(
        one => one.value === optionObject.value
      );
      return `${matchingCurrency.displayString}`;
    },
    [currencyOptions]
  );

  const getPlaceholderValue = useCallback(() => {
    let result, match;
    result = 'Currency';
    if (!subFieldValues || !currencyOptions || !currencyOptions[0]) {
      return result;
    }
    match = currencyOptions.find(one => one.name === subFieldValues[0]);
    if (match) {
      result = match.text;
    }
    return result;
  }, [currencyOptions, subFieldValues]);

  const placeholder = getPlaceholderValue();

  const viewProps = {
    asyncCurrencyOptions,
    currencyOptions,
    currencySelectSubFieldIndex,
    numberValueSubFieldIndex,
    placeholder,
    openMenuOptionParser,
    readOnly,
    subFieldValues,
    setSubFieldValue
  };

  return <CurrencyComboFieldView {...viewProps} />;
};

export default CurrencyComboFieldEngine;
